import {CustomFormGroup} from "./custom-form-group";
import {IGenericKeyValue} from "../interfaces/generic.interface";
import {CustomFormControl} from "./custom-form-control";

export class GenericKeyValueFormGroup extends CustomFormGroup<IGenericKeyValue> {
  constructor(genericKeyValue: IGenericKeyValue) {
    super(genericKeyValue, {
      key: new CustomFormControl<string>(),
      value: new CustomFormControl<string>()
    });
  }

  get keyFC(): CustomFormControl<string> {
    return this.get('key') as CustomFormControl<string>;
  }

  get valueFC(): CustomFormControl<string> {
    return this.get('value') as CustomFormControl<string>;
  }

  override getMergedState(): IGenericKeyValue {
    return {
      ...this.initialState,
      key: this.keyFC.value,
      value: this.valueFC.value
    }
  }
}
